import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

import { OrganicMatterTable } from '../../models';

@Component({
  selector: 'app-organic-matter-table',
  templateUrl: './organic-matter-table.component.html',
  styleUrls: ['./organic-matter-table.component.scss'],
  standalone: false,
})
export class OrganicMatterTableComponent {
  @Input() tableReportData$: Observable<OrganicMatterTable[]>;
  displayedColumns = ['name', 'total', 'perHectare'];
}
